export const LogChangedIcon = () => (<i className="fa-regular fa-right-long pd-l-8 pd-r-8"/>)
